var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    className: "design-iconfont",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 10.103V10.25C11.75 11.6997 10.5748 12.875 9.12501 12.875H8.00001V14H9.12501C10.9392 14 12.4525 12.7117 12.8 11H13.1C13.5971 11 14 10.5971 14 10.1V7.4C14 6.90294 13.5971 6.5 13.1 6.5H12.8608C12.6693 3.98283 10.5662 2 8.00001 2C5.43379 2 3.3307 3.98283 3.13921 6.5H2.9C2.40294 6.5 2 6.90294 2 7.4V10.1C2 10.5971 2.40294 11 2.9 11H3.35C3.84706 11 4.25 10.5971 4.25 10.1V7.4C4.25 6.96879 3.94674 6.6084 3.54186 6.52049C3.94557 6.60814 4.24826 6.9667 4.25 7.39626V6.875C4.25 4.80393 5.92894 3.125 8.00001 3.125C10.0711 3.125 11.75 4.80393 11.75 6.875V7.39697C11.75 7.39798 11.75 7.39899 11.75 7.4V10.1C11.75 10.101 11.75 10.102 11.75 10.103Z",
    fill: "#0A6CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f8c92e0d7ab5be34356d5f5a2bc0e5e4.svg";
export { ForwardRef as ReactComponent };